import { SxProps } from "@mui/material";

export const HeaderStyle: SxProps = {
  bgcolor: "background.paper",
  p: "0 16px",
  height: "72px",
  width: "100%",
  borderBottom: "1px solid",
  borderColor: "divider",
};

export const CategorySelectorStyle: SxProps = {
  height: "72px",
  backgroundColor: "#ffffff",
  borderRadius: 0,
  typography: "display",
  fontWeight: "medium",
  "> fieldset": {
    border: "none",
  },
};

export const CategoryMenuStyle: SxProps = {
  ".MuiPaper-root": {
    boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.08)",
    ".MuiList-root": {
      ".MuiButtonBase-root": {
        padding: "12px 16px",
        typography: "subtitle1",
        fontWeight: "regular",
        ":not(:last-child)": {
          borderBottom: "1px solid",
          borderColor: "divider",
        },
      },
    },
  },
};

export const PanelWrapper: SxProps = {
  backgroundColor: "#ffffff",
  width: "300px",
  borderRight: "1px solid",
  borderColor: "divider",
  height: "100%",
};

export const PanelItemsContainer: SxProps = {
  p: 2,
  height: "100%",
  overflowY: "hidden",

  ":hover": {
    overflowY: "auto",
  },
};

export const MenuItemStyle: SxProps = {
  borderRadius: "8px",
  p: "10px",
  cursor: "pointer",
};
